import { createPortal } from 'react-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { APP_NAME } from '@/constants';

export function hideBootLoader() {
  const el = document.getElementById('app-boot-loader');
  if (!el) return;
  el.classList.add('is-hidden');
  window.setTimeout(() => el.remove(), 280);
}

/** Full-viewport loader portaled into document.body (auth hydrate / first paint). */
export function AppLoader({ label = 'Loading' }: { label?: string }) {
  if (typeof document === 'undefined') return null;
  return createPortal(
    <Box
      className="app-body-loader"
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 1400,
        display: 'grid',
        placeItems: 'center',
        bgcolor: 'background.default',
      }}
    >
      <Box sx={{ textAlign: 'center', px: 2 }}>
        <Box
          component="img"
          src="/appicon.png"
          alt={APP_NAME}
          sx={{ width: 72, height: 72, mb: 2, display: 'block', mx: 'auto' }}
        />
        <CircularProgress size={28} />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
          {label}
        </Typography>
      </Box>
    </Box>,
    document.body,
  );
}

/** Inline loader for the application content body (route Suspense). */
export function AppBodyLoader({ label = 'Loading' }: { label?: string }) {
  return (
    <Box
      sx={{
        minHeight: { xs: 280, md: 420 },
        display: 'grid',
        placeItems: 'center',
        py: 6,
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress size={32} />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1.5 }}>
          {label}
        </Typography>
      </Box>
    </Box>
  );
}
